import PaginaQuemSomos from "./PaginaQuemSomos";
export default PaginaQuemSomos;